import React, { useEffect, useState } from "react";
import { Box, Button, Flex, Radio, RadioGroup, SimpleGrid, Text, Textarea, useToast, VStack } from "@chakra-ui/react";
import IssbContainer from "../IssbContainer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "../../../config";
import { useCloseAudit, useGetActiveAudit } from "../../../hooks/query";
import { showErrorToast } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import FileListWithBrowseOrUpload from "../components/FileListWithBrowseOrUpload";
import { hideAppSpinner, showAppSpinner } from "../../../context/Store/slices/appSpinnerSlice";
import LocalSpinner from "../../../components/LocalSpinner";
import useAirUserRoles from "utils/AuthUtils";
import AuditInfo from "./components/AuditInfo";

const IssbCompleteAudit = () => {
  const [conformity, setConformity] = useState("Yes");
  const dispatch = useDispatch();

  // const [auditData, setAuditData] = useState(null);

  const navigate = useNavigate();
  const toast = useToast();

  const [searchParams] = useSearchParams();
  const stageId = parseInt(searchParams.get("stageId"));
  const stageName = searchParams.get("stageName");

  const { isController, getAirRoles } = useAirUserRoles();

  // only controller can close audit
  useEffect(() => {
    if (!isController()) {
      const controllers = getAirRoles()?.controllers;
      showErrorToast(
        toast,
        "Sorry: Only Round Controllers " + (controllers || "") + " or Organisation Admins can close audits"
      );
      navigate(routes.issbRequirements);
    }
  }, [isController, navigate, getAirRoles, toast]);

  // const roundSelector = useSelector(
  //   (state) => state.issbRound
  // );

  // const questionnaireId = roundSelector.selectedRound?.id;

  // const { isLoading } = useGetActiveAudit(stageId, {
  //   onSuccess: (data) => {
  //     setAuditData(data);
  //   },
  //   onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
  //   cacheTime: 0,
  //   enabled: true,
  // });

  const { audits } = useSelector((state) => state.issbRound || {});
  const auditData = audits?.find((audit) => audit?.stageName === stageName && audit?.isActive === true); // Use `find` for a single match

  const getRequestConfig = () => {
    return {
      onMutate: () => dispatch(showAppSpinner()),
      onSuccess: () => {
        navigate(routes.issbAuditControl);
      },
      onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
      onSettled: () => dispatch(hideAppSpinner()),
    };
  };

  const { mutate: closeAudit } = useCloseAudit(getRequestConfig());

  const handleCloseAudit = () => {
    closeAudit({
      stageId: stageId,
    });
  };

  // if (isLoading) {
  //   return <LocalSpinner />;
  // }

  return auditData ? (
    <IssbContainer margin="20%">
      <VStack align="start" spacing={2}>
        <Text fontSize="heading.2xl" fontWeight="bold" color="darkTeal">
          Complete {auditData?.stageName}
        </Text>
        <Text fontSize="body.m" color="gray.500">
          From here you can initiate an audit and manage its settings.
        </Text>
      </VStack>

      <AuditInfo auditData={auditData} />

      <Box>
        <Text fontSize="body.s" fontWeight="500" color="gray.500" mb={2}>
          Audit Statement
        </Text>

        <Textarea
          borderRadius="md"
          color="whiteShade.500"
          minH="180px"
          placeholder="Type audit statement here"
          size="body.s"
          p={3}
        />
      </Box>

      <Flex justify="space-between">
        <Button variant="outline" colorScheme="gray" onClick={() => navigate(routes.issbAuditControl)} w="120px">
          Exit
        </Button>
        <Button variant="primary" onClick={() => handleCloseAudit()}>
          Submit
        </Button>
      </Flex>
    </IssbContainer>
  ) : (
    <IssbContainer margin="20%">
      <Text fontSize="heading.m">There is no active audit for {stageName}</Text>
      <Button
        mt={4}
        onClick={() => navigate(`${routes.issbStartAudit}?stageId=${stageId}&stageName=${stageName}`)}
        variant="secondary"
      >
        Start the {stageName}
      </Button>
    </IssbContainer>
  );
};

export default IssbCompleteAudit;
